import gql from 'graphql-tag';


import { querySelector } from '../../../utils';
import { GetAllMissingTicketNumbers } from './allMissingTicketNumbers';


const ExpectedTicketNumberSet = gql`
  mutation ExpectedTicketNumberSet($input: ExpectedTicketNumberSetInput!) {
    expected_ticket_number_set(input: $input) {
      id
      ticketNumber: ticket_number
      expected
      reason
    }
  }
`;


const ExpectedTicketNumberSetApi = async (client, id, expected, reason, viewNotExpected) => {
  const variables = {
    input: {
      id,
      expected,
      reason,
    },
  };

  const options = {
    mutation: ExpectedTicketNumberSet,
    variables,
    refetchQueries: [
      { query: GetAllMissingTicketNumbers,
        variables: { only_not_expected: !viewNotExpected },
      },
    ],
  };

  const vars = { only_not_expected: viewNotExpected };
  const cachedQueryResults = client.readQuery({ query: GetAllMissingTicketNumbers, variables: vars });

  const oldCollection = querySelector(cachedQueryResults, '$.missingTicketNumberSequences.edges[*].node', []);

  const result = await client.mutate(options);
  const { data } = await client.query({ query: GetAllMissingTicketNumbers, variables: vars });
  client.writeQuery({ query: GetAllMissingTicketNumbers, data, options: { vars } });
  const newCollection = querySelector(data, '$.missingTicketNumberSequences.edges[*].node', []);

  return {
    result,
    newCollection,
    oldCollection,
  };
};


export default ExpectedTicketNumberSetApi;
